module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_03_6DB79_1SB_HIT.a818448f.jpg";